export const NAV_ITEMS = [
  ['feed', 'Start', 'home'],
  ['discover', 'Entdecken', 'compass'],
  ['groups', 'Gruppen', 'users'],
  ['chats', 'Chats', 'message'],
  ['wallet', 'Guthaben', 'wallet'],
  ['profile', 'Profil', 'user']
];

export function parseEuroCents(value) {
  const input = String(value ?? '').trim();
  if (!/^\d+(?:[,.]\d{1,2})?$/.test(input)) return null;
  const [euros, fraction = ''] = input.replace(',', '.').split('.');
  const cents = Number(euros) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(cents) ? cents : null;
}

export function euroInputValue(cents) {
  const amount = Number(cents);
  if (!Number.isSafeInteger(amount) || amount < 0) return '0,00';
  return `${Math.floor(amount / 100)},${String(amount % 100).padStart(2, '0')}`;
}

export function createId(prefix = 'id') {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

export function toggleIn(list, value) {
  return list.includes(value) ? list.filter((entry) => entry !== value) : [...list, value];
}

export function formatRelative(iso, now = Date.now()) {
  const minutes = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 60000));
  const locale = typeof document !== 'undefined' && document.documentElement.lang === 'en' ? 'en' : 'de';
  if (minutes < 1) return locale === 'en' ? 'just now' : 'gerade eben';
  if (minutes < 60) return locale === 'en' ? `${minutes} min ago` : `vor ${minutes} Min.`;
  if (minutes < 1440) return locale === 'en' ? `${Math.floor(minutes / 60)} hr ago` : `vor ${Math.floor(minutes / 60)} Std.`;
  return locale === 'en' ? `${Math.floor(minutes / 1440)} d ago` : `vor ${Math.floor(minutes / 1440)} T.`;
}

export function filterPosts(posts, query, topic = 'Alle') {
  const needle = query.trim().toLocaleLowerCase('de');
  return posts.filter((post) => {
    const topicMatch = topic === 'Alle' || post.topics.includes(topic);
    const haystack = `${post.author.name} ${post.author.username} ${post.text} ${post.topics.join(' ')}`.toLocaleLowerCase('de');
    return topicMatch && (!needle || haystack.includes(needle));
  });
}

export function unreadCount(chats) {
  return chats.reduce((sum, chat) => sum + (chat.unread || 0), 0);
}
